import { ActionType, createAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { DTO } from './types'

export const addMessagesOnActiveChatAction = createAction('@chat/ADD_MESSAGES_ON_ACTIVE_CHAT')<DTO>()

const success = (state: ChatState, action: ActionType<typeof addMessagesOnActiveChatAction>): ChatState => {
  const messagesToAdd = action.payload
  const updatedMessages = state.activeChat?.messages?.length ? [...state.activeChat?.messages] : []

  messagesToAdd.forEach(messageToAdd => {
    const messageIndex = updatedMessages?.findIndex(message => message.messageId === messageToAdd.messageId)
    if (messageIndex === -1) {
      updatedMessages.unshift(messageToAdd)
    } else {
      updatedMessages[messageIndex] = messageToAdd
    }
  })

  return {
    ...state,
    activeChat: {
      ...state.activeChat,
      messages: updatedMessages
    }
  }
}

export const addMessagesOnActiveChatHandle = { asyncAction: addMessagesOnActiveChatAction, success }
